import type { ListProjectWorkStatusUpdatesParams } from '@amarantos/api-client'
import { WorkStatusType } from '@amarantos/api-client'
import { z } from 'zod/v3'

import { issueStatuses } from './issue-statuses'

export const workStatusScopeValues = ['issues', 'progress', 'deliveries'] as const
export type WorkStatusScope = (typeof workStatusScopeValues)[number]

const baseWorkStatusUpdatesSearchSchema = z.object({
	scope: z.enum(workStatusScopeValues).default('issues'),
	page: z.coerce.number().int().positive().default(1),
})

export const workStatusUpdateDrawerSearchSchema = z.union([
	z.object({
		mode: z.literal('review'),
		workStatusUpdateId: z.coerce.number().int().positive(),
	}),
	z.object({
		mode: z.undefined().optional(),
		workStatusUpdateId: z.undefined().optional(),
	}),
])

export type WorkStatusUpdateDrawerSearch = z.infer<typeof workStatusUpdateDrawerSearchSchema>

export const workStatusUpdatesSearchSchema = baseWorkStatusUpdatesSearchSchema.and(workStatusUpdateDrawerSearchSchema)

export type WorkStatusUpdatesSearch = z.infer<typeof workStatusUpdatesSearchSchema>

export const WORK_STATUS_UPDATES_PAGE_SIZE = 10

const workStatusScopeStatuses: Record<WorkStatusScope, WorkStatusType[]> = {
	progress: [WorkStatusType.completed, WorkStatusType.in_progress, WorkStatusType.on_hold],
	issues: [...issueStatuses],
	deliveries: [WorkStatusType.delivery, WorkStatusType.consumption],
}

export function getWorkStatusScopeStatuses(scope: WorkStatusScope): WorkStatusType[] {
	return workStatusScopeStatuses[scope]
}

export function toListWorkStatusUpdatesParams(
	projectId: number,
	page: number,
	statuses: WorkStatusType[],
	perPage = WORK_STATUS_UPDATES_PAGE_SIZE,
): ListProjectWorkStatusUpdatesParams {
	return {
		page,
		per_page: perPage,
		project_ids: [projectId],
		status: statuses,
	}
}
